import $ from 'jquery';
import {Component} from '../../../component';

export class HeaderSearch extends Component {

    constructor(context) {
        super(context);

        this.$bodyEl = $('body');
        this.$headerSearchEl = $('.js-site-search-header');
        this.$headerSearchToggleEl = $('.js-site-header-search-toggle');
    }

    /**
     * setup
     */
    setup() {
        this.$headerSearchToggleEl.on('click', this.toggleSearch.bind(this));
        $(document).on('click', this.handleOutsideClicks.bind(this));
    }

    /**
     * toggle
     */
    toggleSearch(evt) {
        if (evt) {
            evt.preventDefault();
        }

        this.toggle();
    }

    /**
     * toggle
     */
    toggle() {
        this.$bodyEl.toggleClass('site-search-header--active');

        const $inputEl = this.$headerSearchEl.find('.search-field');

        if (this.isActive()) {
            setTimeout(() => {
                $inputEl.trigger('focus');
            }, 250);
        } else {
            setTimeout(() => {
                $inputEl.trigger('blur');
            }, 250);
        }
    }

    /**
     * Checks if search field is active.
     *
     * @returns {Boolean}
     */
    isActive() {
        return this.$bodyEl.hasClass('site-search-header--active');
    }

    /**
     * Checks if search field is active.
     *
     * @returns {Boolean}
     */
    handleOutsideClicks(evt) {
        if (
            (!this.$headerSearchEl.is(evt.target) && this.$headerSearchEl.has(evt.target).length === 0)
            &&
            (!this.$headerSearchToggleEl.is(evt.target) && this.$headerSearchToggleEl.has(evt.target).length === 0)
            &&
            this.isActive()
        ) {
            this.toggle();
        }
    }
}
